<template>
  <!-- Associated Sites -->
  <section class="container bg-secondary">
    <div class="row justify-content-center">
      <div class="col col-lg-10">
        <h5 class="text-uppercase">Associated Sites</h5>

        <div class="row justify-content-between">
          <div class="col-6 col-sm-4 my-3">
            <a
              href="https://www.trailfinders.com"
              class="box-link has-hover-s1 has-arrow-s1"
              target="_blank"
            >
              <img
                src="../assets/img/logo-tf.svg"
                class="img-fluid p-3 px-md-4"
                alt=""
              />
            </a>
          </div>
          <div class="col-6 col-sm-4 my-3">
            <a
              href="http://www.tfsc.co.uk"
              class="box-link has-hover-s1 has-arrow-s1"
              target="_blank"
            >
              <img
                src="../assets/img/logo-tfsc.png"
                class="img-fluid p-3 px-md-4 px-xl-5"
                alt=""
              />
            </a>
          </div>
          <div class="col-6 col-sm-4 my-3">
            <a
              href="http://www.ealingtrailfinders.com"
              class="box-link has-hover-s1 has-arrow-s1"
              target="_blank"
            >
              <img
                src="../assets/img/logo-tfrc.svg"
                class="img-fluid p-3 px-md-4 px-xl-5"
                height="10"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
